class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }

  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() { 
    /************************************************
   * 🔹 ONLY RUN WHEN MEGA MENU OPENS
   ************************************************/
  if (!this.mainDetailsToggle.open) return;

  // Scope to CURRENT mega menu only
  const megaMenu = this.mainDetailsToggle.querySelector(
    '.header__mega-menu-carousel-grid'
  );
  if (!megaMenu) return;

  // Small delay to ensure visibility
  setTimeout(() => {

    // 🎯 FIND TARGET SUBLINK
    const targetSubmenu = megaMenu.querySelector(
      '.header__mega-menu-carousel-nav-sublink-1-1[data-megamenu-carousel-toggle]'
    );
    if (!targetSubmenu) return;

    // 🔥 CLICK SUBMENU
    targetSubmenu.click();

    // 🔁 OPTIONAL: FORCE SWIPER UPDATE
    setTimeout(() => {
      const tabId = targetSubmenu.getAttribute('aria-controls');
      const swiperEl = document
        .getElementById(tabId)
        ?.querySelector('.product-grid-slider');

      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
        swiperEl.swiper.slideTo(0, 0);
      }
    }, 50);

  }, 50);
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
